var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-line/~/lodash/_assocIndexOf.js
// module id = ./node_modules/victory-brush-line/node_modules/lodash/_assocIndexOf.js
// module chunks = 1